export const APP_VERSION = '0.1.1';
export const APP_LAST_UPDATED = '2026-04-18';
